import { render, staticRenderFns } from "./BundleEdit.vue?vue&type=template&id=2e2e6444&scoped=true"
import script from "./BundleEdit.vue?vue&type=script&lang=js"
export * from "./BundleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e6444",
  null
  
)

export default component.exports